export default __webpack_public_path__ + "static/media/snoop (2).f29cfafa.png";